import axios from '@/http/index';

const base = '';
// 获取新增会员的链接地址
export const getSignSuccess = (param) => axios.get(`${base}/erp/login/loginSuccess`, param).then((res) => res.data);
// 退出登录
export const getOutLogin = (param) => axios.get(`${base}/erp/login/out`, param).then((res) => res.data);
// 商家切换门店
export const getChangeStore = (param) => axios.get(`${base}/erp/login/changeStore`, param).then((res) => res.data);
// 获取二维码
export const getBusQRCode = (param) => axios.get(`${base}/erp/home/getBusQRCode`, param).then((res) => res.data);
// 获取打印机列表
export const getPrintSetList = (param) => axios.get(`${base}/erp/print/getPrintSetList`, param).then((res) => res.data);
// 保存打印机id
export const savePrintSetId = (param) => axios.get(`${base}/erp/print/savePrintSetId`, param).then((res) => res.data);
// 获得erp登录rl域名前缀
export const getErpLoginUrl = (param) => axios.get(`${base}/urlApi/79B4DE7C/getErpLoginUrl`, param).then((res) => res.data);
// (3.6.2)获取商家帐号信息
export const getAccountMsg = (param) => axios.get(`${base}/erp/login/getAccountMsg`, param).then((res) => res.data);

/// ////************************** */
// 获取首页未完成订单列表
export const getIndexOrderList = (param) => axios.get(`${base}/erp/home/getHomeMsg`, param).then((res) => res.data);
// 获取首页当天收入信息
export const getIndexMsg = (params) => axios.get(`${base}/erp/home/getHomeMsg`, params).then((res) => res.data);
// 获取新增会员的链接地址
export const getMemberManageSrc = (param) => axios.get(`${base}/member/getMemberUrl`, param).then((res) => res.data);
// 订单是否存在未读(存在：true,不存在：false)
export const getBookReadStatus = (param) => axios.get(`${base}/erp/bookOrder/getBookReadStatus`, param).then((res) => res.data);
// 订单是否存在未读(存在：true,不存在：false)
export const getSocket2 = (param) => axios.get(`${base}/core/lookArticle/getSocket2`, param).then((res) => res.data);

// 评价(存在：true,不存在：false)
export const getAssessSocket2 = (param) => axios.get(`${base}/core/lookArticle/getAssessSocket2`, param).then((res) => res.data);

// 查询公告列表页展示功能
export const queryArticles = (id, params) => axios.get(`${base}/core/lookArticle/queryArticles?mainId=${id}`, params).then((res) => res.data);

// 查询公告列表页展示功能
export const getCommonName = (params) => axios.get(`${base}/common/getCommonName`, params).then((res) => res.data);

// 5.9ERP首页点击手牌展示列表
export const getHandCards = (params) => axios.get(`${base}/erp/customerOrder/getHandCards`, params).then((res) => res.data);

// (4.1订单详情)获得服务开单订单详情
export const getOrderDetail4AllDto = (param) => axios.get(`${base}/erp/customerOrder/getOrderDetail4AllDto`, param).then((res) => res.data);

// (4.7.0)获得导入历史记录
export const getImportRecordList = (params) => axios.get(`${base}/erp/customer/getImportRecordList`, params).then((res) => res.data);

// 获取导入导出进度
export const getProcessProgress = (params) => axios.get(`${base}/common/getProcessProgress`, params).then((res) => res.data);

// 获取导入导出进度
export const randomProcessId = (params) => axios.get(`${base}/common/randomProcessId`, params).then((res) => res.data);

// (6.0)获取导入结果信息
export const getImportMsg = (params) => axios.get(`${base}/common/getImportMsg`, params).then((res) => res.data);
// (6.0)获取导出结果信息
export const getExportMsg = (params) => axios.get(`${base}/common/getExportMsg`, params).then((res) => res.data);

// 6.3获得token值
export const getToken = (params) => axios.get(`${base}/erp/login/getCookiesMsg`, params).then((res) => res.data);
